import "~/css/forms.css"; // ensure our form reset styles are loaded

import { forwardRef } from "react";
import { cx } from "~lib/utils";

import styles from "./Input.module.css";

export const Input = forwardRef(
  /** @param {React.HTMLProps<HTMLInputElement> & { className?: string }} props */
  function Input(props, ref) {
    return (
      <input
        {...props}
        className={cx(styles.input, styles[props.type || "text"], props.className)}
        ref={ref}
      />
    );
  }
);

export default Input;
